import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AccountManagerService } from '../service/account-manager.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectionGuard implements CanActivate {
  private accountManager = inject(AccountManagerService);

  public disableRoutes = ['/login', '/init', '/select-account'];

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isValidUrl = !this.disableRoutes.find((url) => url === state.url);
    if (isValidUrl) {
      this.accountManager.saveRoute = state.url;
    }
    return true;
  }
}
